import { render, staticRenderFns } from "./FarmersVerifier.vue?vue&type=template&id=286ce001&scoped=true&"
import script from "./FarmersVerifier.vue?vue&type=script&lang=js&"
export * from "./FarmersVerifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286ce001",
  null
  
)

export default component.exports